import { retryEvent } from "@/utils/retryEvent";

export const syteTrackEvent = (data: any) => {
  retryEvent(
    "syteDataLayer",
    () => !!window.syteDataLayer,
    () => window.syteDataLayer.push(data)
  );
};
